import CredentialsModal from '../components/credentialsModal'
import QuickbooksIdField from '../components/fields/QuickbooksId.vue'
import QuickbooksSalesReceipt from '../components/fields/QuickbooksSalesReceipt.vue'
import QuickbooksInvoice from '../components/fields/QuickbooksInvoice.vue'
import QuickbooksCustomer from '../components/fields/QuickbooksCustomer.vue'
import QuickbooksSysChargeId from '../components/fields/QuickbooksSysChargeId.vue'
import QuickbooksProductService from '../components/fields/QuickbooksProductService.vue'
import CustomQuestions from '../components/fields/CustomQuestions.vue'
import AutoCompleteField from '../components/fields/AutoCompleteField'
import AutoCompleteManyField from '../components/fields/AutoCompleteManyField'
import RelationFieldMany from '../components/fields/RelationFieldMany'
import RelationFieldOne from '../components/fields/RelationFieldOne'
import AutoSaver from '../components/form/AutoSaver'
import SelectOneField from '../components/fields/SelectOneField'
import SelectManyField from '../components/fields/SelectManyField'
import ImageUploadField from '../components/fields/ImageUploadField'
import FileUploadField from '../components/fields/FileUploadField'
import AccordionField from '../components/fields/AccordionField'
import FilterBar from '../components/table/FilterBar'
import GridCell from '../components/table/GridCell'
import GridCellBoolean from '../components/table/GridCellBoolean'
import GridCellDate from '../components/table/GridCellDate'
import GridCellIcon from '../components/table/GridCellIcon'
import GridCellFile from '../components/table/GridCellFile'
import GridCellImage from '../components/table/GridCellImage'
import GridCellNumber from '../components/table/GridCellNumber'
import GridCellRelationMany from '../components/table/GridCellRelationMany'
import GridCellRelationOne from '../components/table/GridCellRelationOne'
import GridCellRepeat from '../components/table/GridCellRepeat'
import TextFilter from '../components/table/TextFilter'
import SelectFilter from '../components/table/SelectFilter'
import DateFilter from '../components/table/DateFilter'
import GridCellString from '../components/table/GridCellString'
import GridCellActionDelete from '../components/table/GridCellActionDelete'
import GridCellActionEdit from '../components/table/GridCellActionEdit'
import BaseList from '../components/list/BaseList'
import SelectList from '../components/list/SelectList'
import LayoutCards from '../components/list/LayoutCards'
import LayoutTable from '../components/list/LayoutTable'
import SelectLayoutTable from '../components/list/SelectLayoutTable'
import LayoutAccordion from '../components/list/LayoutAccordion'
import BaseForm from '../components/form/BaseForm'
import AzBar from '../components/list/AzBar'
import Breadcrumbs from '../components/layout/Breadrumbs'
import SidebarNav from '../components/layout/SidebarNav'
import IpAddressChips from '../components/fields/IpAddressChips'

export default ({ Vue }) => {
  Vue.component('custom-questions', CustomQuestions)
  Vue.component('quickbooks-id', QuickbooksIdField)
  Vue.component('quickbooks-sales-receipt', QuickbooksSalesReceipt)
  Vue.component('quickbooks-invoice', QuickbooksInvoice)
  Vue.component('quickbooks-customer', QuickbooksCustomer)
  Vue.component('quickbooks-sys-charge-id', QuickbooksSysChargeId)
  Vue.component('quickbooks-product-service', QuickbooksProductService)
  Vue.component('relation-field-one', RelationFieldOne)
  Vue.component('relation-field-many', RelationFieldMany)
  Vue.component('credentials-modal', CredentialsModal)
  Vue.component('auto-saver', AutoSaver)
  Vue.component('date-filter', DateFilter)
  Vue.component('select-filter', SelectFilter)
  Vue.component('text-filter', TextFilter)
  Vue.component('select-one-field', SelectOneField)
  Vue.component('select-many-field', SelectManyField)
  Vue.component('auto-complete-field', AutoCompleteField)
  Vue.component('auto-complete-many-field', AutoCompleteManyField)
  Vue.component('ip-address-chips', IpAddressChips)
  Vue.component('image-upload-field', ImageUploadField)
  Vue.component('file-upload-field', FileUploadField)
  Vue.component('accordion-field', AccordionField)
  Vue.component('filter-bar', FilterBar)
  Vue.component('grid-cell-boolean', GridCellBoolean)
  Vue.component('grid-cell-repeat', GridCellRepeat)
  Vue.component('grid-cell-date', GridCellDate)
  Vue.component('grid-cell-icon', GridCellIcon)
  Vue.component('grid-cell-image', GridCellImage)
  Vue.component('grid-cell-file', GridCellFile)
  Vue.component('grid-cell-number', GridCellNumber)
  Vue.component('grid-cell-relation-many', GridCellRelationMany)
  Vue.component('grid-cell-relation-one', GridCellRelationOne)
  Vue.component('grid-cell-string', GridCellString)
  Vue.component('grid-cell-text', GridCellString)
  Vue.component('grid-cell-action-delete', GridCellActionDelete)
  Vue.component('grid-cell-action-edit', GridCellActionEdit)
  Vue.component('grid-cell', GridCell)
  Vue.component('layout-table', LayoutTable)
  Vue.component('select-layout-table', SelectLayoutTable)
  Vue.component('layout-cards', LayoutCards)
  Vue.component('layout-accordion', LayoutAccordion)
  Vue.component('base-form', BaseForm)
  Vue.component('az-bar', AzBar)
  Vue.component('base-list', BaseList)
  Vue.component('select-list', SelectList)
  Vue.component('breadcrumbs', Breadcrumbs)
  Vue.component('sidebar-nav', SidebarNav)
}
